import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './head.css';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'services', label: 'Services' },
    { id: 'contacts', label: 'Contact' }
  ];

  const menuVariants = {
    hidden: { opacity: 0, x: '100%' },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { 
        type: 'tween',
        ease: [0.25, 1, 0.5, 1],
        duration: 0.3
      }
    },
    exit: { 
      opacity: 0, 
      x: '100%',
      transition: { 
        ease: [0.25, 1, 0.5, 1],
        duration: 0.2
      }
    }
  };

  const linkVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.3
      }
    })
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <motion.div 
          className="brand"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1>Globepawa Ventures</h1>
        </motion.div>

        <nav className="desktop-nav">
          <ul>
            {navLinks.map((link, index) => (
              <motion.li 
                key={link.id}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 + index * 0.1 }}
              >
                <a 
                  href={`#${link.id}`}
                  className="nav-link"
                >
                  {link.label}
                  <span className="nav-underline"></span>
                </a>
              </motion.li>
            ))}
          </ul>
        </nav>

        <motion.div 
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          whileTap={{ scale: 0.9 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <div className={`bar ${menuOpen ? 'rotate1' : ''}`}></div>
          <div className={`bar ${menuOpen ? 'fade' : ''}`}></div>
          <div className={`bar ${menuOpen ? 'rotate2' : ''}`}></div>
        </motion.div>

        <AnimatePresence>
          {menuOpen && (
            <motion.div 
              className="mobile-nav"
              variants={menuVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              <ul>
                {navLinks.map((link, index) => (
                  <motion.li 
                    key={link.id}
                    variants={linkVariants}
                    initial="hidden"
                    animate="visible"
                    custom={index}
                    onClick={() => setMenuOpen(false)}
                  >
                    <a href={`#${link.id}`}>{link.label}</a>
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
}